namespace Nobox.CRM {
    export interface TaskForm {
        Nama: Serenity.StringEditor;
        Ket: Serenity.HtmlContentEditor;
        Hasil: Serenity.HtmlContentEditor;
        Lampiran: Serenity.MultipleImageUploadEditor;
        BoardId: Serenity.ServiceLookupEditor;
        Owner: Serenity.ServiceLookupEditor;
        IsDone: Serenity.BooleanEditor;
        ListId: Serenity.ServiceLookupEditor;
        KategoriId: Serenity.ServiceLookupEditor;
        Color: ColorKanbanEditor;
        Tags: Serenity.ServiceLookupEditor;
        Mulai: CustomDateTimeEditor;
        Selesai: CustomDateTimeEditor;
        KontakId: Serenity.ServiceLookupEditor;
        GroupId: Serenity.ServiceLookupEditor;
        DealId: Serenity.ServiceLookupEditor;
        In: CustomDateTimeEditor;
        Up: CustomDateTimeEditor;
        InBy: Serenity.ServiceLookupEditor;
        UpBy: Serenity.ServiceLookupEditor;
        ShowBoard: Serenity.IntegerEditor;
    }

    export class TaskForm extends Serenity.PrefixedContext {
        static formKey = 'Nobox.Task';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!TaskForm.init)  {
                TaskForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.HtmlContentEditor;
                var w2 = s.MultipleImageUploadEditor;
                var w3 = s.ServiceLookupEditor;
                var w4 = s.BooleanEditor;
                var w5 = ColorKanbanEditor;
                var w6 = CustomDateTimeEditor;
                var w7 = s.IntegerEditor;

                Q.initFormType(TaskForm, [
                    'Nama', w0,
                    'Ket', w1,
                    'Hasil', w1,
                    'Lampiran', w2,
                    'BoardId', w3,
                    'Owner', w3,
                    'IsDone', w4,
                    'ListId', w3,
                    'KategoriId', w3,
                    'Color', w5,
                    'Tags', w3,
                    'Mulai', w6,
                    'Selesai', w6,
                    'KontakId', w3,
                    'GroupId', w3,
                    'DealId', w3,
                    'In', w6,
                    'Up', w6,
                    'InBy', w3,
                    'UpBy', w3,
                    'ShowBoard', w7
                ]);
            }
        }
    }
}
